import React from 'react';

export function RadioOff(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99987 0.533447C3.87614 0.533447 0.533203 3.87639 0.533203 8.00011C0.533203 12.1238 3.87614 15.4668 7.99987 15.4668C12.1236 15.4668 15.4665 12.1238 15.4665 8.00011C15.4665 3.87639 12.1236 0.533447 7.99987 0.533447ZM7.99987 2.13345C11.2399 2.13345 13.8665 4.76004 13.8665 8.00011C13.8665 11.2402 11.2399 13.8668 7.99987 13.8668C4.7598 13.8668 2.1332 11.2402 2.1332 8.00011C2.1332 4.76004 4.7598 2.13345 7.99987 2.13345Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
